import { language } from '@/params'

export function getLocale() {
  const locale = language.replace('_', '-')
  return locale
}
